var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Toggle',{attrs:{"disabled":_vm.disabled,"items":_vm.items},on:{"change":_vm.change},scopedSlots:_vm._u([{key:"default",fn:function(ref){
var ref_val = ref.val;
var val = ref_val.val;
var name = ref_val.name;
return [_c('img',{attrs:{"src":name,"alt":val}})]}}])})}
var staticRenderFns = []

export { render, staticRenderFns }